import React, {Component} from "react";

class InputDate extends Component {
    constructor(props) {
        super(props);

        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        this.state = {
            [name]: this.props.blockItem.values[0]
        };

        const e = {target: {name: name, value: this.props.blockItem.values[0]}}
        this.props.onChange(e);

        this.change = this.change.bind(this);
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        this.props.onChange(e);
    }

    render() {
        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        return (
            <div className="coreBlockItem-value" style={JSON.parse(this.props.blockItem.inputCss)}>
                {this.props.blockItem.isDisplayInfoText &&
                <div id={"coreBlockItem-itemInfo-" + this.props.blockItem.id} className="coreBlockItem-itemInfo">i</div>
                }
                <input type="text"
                       className="coreBlockItem-input coreBlockItem-typeText"
                       autoComplete="off"
                       name={"BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "")}
                       value={this.state[name]}
                       onChange={this.change}/>
            </div>
        );
    }
}

export default InputDate;